export enum Country {
  US = 'US',
  CA = 'CA',
  MX = 'MX',
}

export enum State {
  Alabama = 'alabama',
  Alaska = 'alaska',
  Alberta = 'alberta',
  Arizona = 'arizona',
  Arkansas = 'arkansas',
  BritishColumbia = 'britishColumbia',
  California = 'california',
  Colorado = 'colorado',
  Connecticut = 'connecticut',
  DC = 'dc',
  Delaware = 'delaware',
  Florida = 'florida',
  Georgia = 'georgia',
  Idaho = 'idaho',
  Illinois = 'illinois',
  Indiana = 'indiana',
  Iowa = 'iowa',
  Kansas = 'kansas',
  Kentucky = 'kentucky',
  Louisiana = 'louisiana',
  Maine = 'maine',
  Manitoba = 'manitoba',
  Maryland = 'maryland',
  Massachusetts = 'massachusetts',
  Mexico = 'mexico',
  Michigan = 'michigan',
  Minnesota = 'minnesota',
  Mississippi = 'mississippi',
  Missouri = 'missouri',
  Montana = 'montana',
  Nebraska = 'nebraska',
  Nevada = 'nevada',
  NewBrunswick = 'newBrunswick',
  NewHampshire = 'newHampshire',
  NewJersey = 'newJersey',
  NewMexico = 'newMexico',
  NewYork = 'newYork',
  Newfoundland = 'newfoundland',
  NorthCarolina = 'northCarolina',
  NorthDakota = 'northDakota',
  NWTerritory = 'nwTerritory',
  NovaScotia = 'novaScotia',
  Nunavut = 'nunavut',
  Ohio = 'ohio',
  Oklahoma = 'oklahoma',
  Ontario = 'ontario',
  Oregon = 'oregon',
  Pennsylvania = 'pennsylvania',
  PrinceEdwardIsland = 'princeEdwardIsland',
  Quebec = 'quebec',
  RhodeIsland = 'rhodeIsland',
  Saskatchewan = 'saskatchewan',
  SouthCarolina = 'southCarolina',
  SouthDakota = 'southDakota',
  Tennessee = 'tennessee',
  Texas = 'texas',
  Utah = 'utah',
  YukonTerritory = 'yukonTerritory',
  Vermont = 'vermont',
  Virginia = 'virginia',
  Washington = 'washington',
  WestVirginia = 'westVirginia',
  Wisconsin = 'wisconsin',
  Wyoming = 'wyoming',
}

interface StateMetadata {
  abbreviation: string;
  displayName: string;
  country: Country;
}

export const STATE_METADATA = {
  alabama: { abbreviation: 'AL', displayName: 'Alabama', country: Country.US },
  alaska: { abbreviation: 'AK', displayName: 'Alaska', country: Country.US },
  alberta: { abbreviation: 'AB', displayName: 'Alberta', country: Country.CA },
  arizona: { abbreviation: 'AZ', displayName: 'Arizona', country: Country.US },
  arkansas: {
    abbreviation: 'AR',
    displayName: 'Arkansas',
    country: Country.US,
  },
  britishColumbia: {
    abbreviation: 'BC',
    displayName: 'British Columbia',
    country: Country.CA,
  },
  california: {
    abbreviation: 'CA',
    displayName: 'California',
    country: Country.US,
  },
  colorado: {
    abbreviation: 'CO',
    displayName: 'Colorado',
    country: Country.US,
  },
  connecticut: {
    abbreviation: 'CT',
    displayName: 'Connecticut',
    country: Country.US,
  },
  dc: {
    abbreviation: 'DC',
    displayName: 'District of Columbia',
    country: Country.US,
  },
  delaware: {
    abbreviation: 'DE',
    displayName: 'Delaware',
    country: Country.US,
  },
  florida: { abbreviation: 'FL', displayName: 'Florida', country: Country.US },
  georgia: { abbreviation: 'GA', displayName: 'Georgia', country: Country.US },
  idaho: { abbreviation: 'ID', displayName: 'Idaho', country: Country.US },
  illinois: {
    abbreviation: 'IL',
    displayName: 'Illinois',
    country: Country.US,
  },
  indiana: { abbreviation: 'IN', displayName: 'Indiana', country: Country.US },
  iowa: { abbreviation: 'IA', displayName: 'Iowa', country: Country.US },
  kansas: { abbreviation: 'KS', displayName: 'Kansas', country: Country.US },
  kentucky: {
    abbreviation: 'KY',
    displayName: 'Kentucky',
    country: Country.US,
  },
  louisiana: {
    abbreviation: 'LA',
    displayName: 'Louisiana',
    country: Country.US,
  },
  maine: { abbreviation: 'ME', displayName: 'Maine', country: Country.US },
  manitoba: {
    abbreviation: 'MB',
    displayName: 'Manitoba',
    country: Country.CA,
  },
  maryland: {
    abbreviation: 'MD',
    displayName: 'Maryland',
    country: Country.US,
  },
  massachusetts: {
    abbreviation: 'MA',
    displayName: 'Massachusetts',
    country: Country.US,
  },
  mexico: { abbreviation: 'MX', displayName: 'Mexico', country: Country.MX },
  michigan: {
    abbreviation: 'MI',
    displayName: 'Michigan',
    country: Country.US,
  },
  minnesota: {
    abbreviation: 'MN',
    displayName: 'Minnesota',
    country: Country.US,
  },
  mississippi: {
    abbreviation: 'MS',
    displayName: 'Mississippi',
    country: Country.US,
  },
  missouri: {
    abbreviation: 'MO',
    displayName: 'Missouri',
    country: Country.US,
  },
  montana: { abbreviation: 'MT', displayName: 'Montana', country: Country.US },
  nebraska: {
    abbreviation: 'NE',
    displayName: 'Nebraska',
    country: Country.US,
  },
  nevada: { abbreviation: 'NV', displayName: 'Nevada', country: Country.US },
  newBrunswick: {
    abbreviation: 'NB',
    displayName: 'New Brunswick',
    country: Country.CA,
  },
  newHampshire: {
    abbreviation: 'NH',
    displayName: 'New Hampshire',
    country: Country.US,
  },
  newJersey: {
    abbreviation: 'NJ',
    displayName: 'New Jersey',
    country: Country.US,
  },
  newMexico: {
    abbreviation: 'NM',
    displayName: 'New Mexico',
    country: Country.US,
  },
  newYork: { abbreviation: 'NY', displayName: 'New York', country: Country.US },
  newfoundland: {
    abbreviation: 'NL',
    displayName: 'Newfoundland',
    country: Country.CA,
  },
  northCarolina: {
    abbreviation: 'NC',
    displayName: 'North Carolina',
    country: Country.US,
  },
  northDakota: {
    abbreviation: 'ND',
    displayName: 'North Dakota',
    country: Country.US,
  },
  nwTerritory: {
    abbreviation: 'NT',
    displayName: 'Northwest Territories',
    country: Country.CA,
  },
  novaScotia: {
    abbreviation: 'NS',
    displayName: 'Nova Scotia',
    country: Country.CA,
  },
  nunavut: { abbreviation: 'NU', displayName: 'Nunavut', country: Country.CA },
  ohio: { abbreviation: 'OH', displayName: 'Ohio', country: Country.US },
  oklahoma: {
    abbreviation: 'OK',
    displayName: 'Oklahoma',
    country: Country.US,
  },
  ontario: { abbreviation: 'ON', displayName: 'Ontario', country: Country.CA },
  oregon: { abbreviation: 'OR', displayName: 'Oregon', country: Country.US },
  pennsylvania: {
    abbreviation: 'PA',
    displayName: 'Pennsylvania',
    country: Country.US,
  },
  princeEdwardIsland: {
    abbreviation: 'PE',
    displayName: 'Prince Edward Island',
    country: Country.CA,
  },
  quebec: { abbreviation: 'QC', displayName: 'Quebec', country: Country.CA },
  rhodeIsland: {
    abbreviation: 'RI',
    displayName: 'Rhode Island',
    country: Country.US,
  },
  saskatchewan: {
    abbreviation: 'SK',
    displayName: 'Saskatchewan',
    country: Country.CA,
  },
  southCarolina: {
    abbreviation: 'SC',
    displayName: 'South Carolina',
    country: Country.US,
  },
  southDakota: {
    abbreviation: 'SD',
    displayName: 'South Dakota',
    country: Country.US,
  },
  tennessee: {
    abbreviation: 'TN',
    displayName: 'Tennessee',
    country: Country.US,
  },
  texas: { abbreviation: 'TX', displayName: 'Texas', country: Country.US },
  utah: { abbreviation: 'UT', displayName: 'Utah', country: Country.US },
  yukonTerritory: {
    abbreviation: 'YT',
    displayName: 'Yukon',
    country: Country.CA,
  },
  vermont: { abbreviation: 'VT', displayName: 'Vermont', country: Country.US },
  virginia: {
    abbreviation: 'VA',
    displayName: 'Virginia',
    country: Country.US,
  },
  washington: {
    abbreviation: 'WA',
    displayName: 'Washington',
    country: Country.US,
  },
  westVirginia: {
    abbreviation: 'WV',
    displayName: 'West Virginia',
    country: Country.US,
  },
  wisconsin: {
    abbreviation: 'WI',
    displayName: 'Wisconsin',
    country: Country.US,
  },
  wyoming: { abbreviation: 'WY', displayName: 'Wyoming', country: Country.US },
} as const satisfies Record<State, StateMetadata>;

export type CanadianState = {
  [StateName in State]: (typeof STATE_METADATA)[StateName]['country'] extends Country.CA
    ? StateName
    : never;
}[State];

export function stateFromAbbreviation(abbreviation: string): State | undefined {
  const normalized = abbreviation.toUpperCase();
  const entry = Object.entries(STATE_METADATA).find(
    ([, metadata]) => metadata.abbreviation === normalized,
  );
  return entry ? (entry[0] as State) : undefined;
}

export function abbreviationFromState(state: State): string {
  return STATE_METADATA[state]?.abbreviation ?? state;
}

export const STATE_ABBREVIATIONS = Object.values(STATE_METADATA).map(
  (metadata) => metadata.abbreviation,
);
